import React, {useCallback} from "react";
import {
	ModalActions,
	ModalBackdrop,
	ModalCloseButton,
	ModalContent,
	ModalHeaderTitle,
	ModalText,
} from "components/Modals/styled";
import {IconInfo, IconRemove} from "components/Icons";
import styled from "styled-components";
import {PrimaryLink, SecondaryButton} from "components/styled";
import {useDispatch, useSelector} from "react-redux";
import {toggleTeamSavedModal} from "modules/actions";
import {getProject, getSport, getTeamSavedModalState} from "modules/selectors";
import {useTranslation} from "react-i18next";

const InnerWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 0 12px;
`;

export const TeamCreatedModal: React.FC = () => {
	const dispatch = useDispatch();
	const {t} = useTranslation();
	const isModalVisible = useSelector(getTeamSavedModalState);
	const sport = useSelector(getSport);
	const project = useSelector(getProject);

	const closeModal = useCallback(() => {
		dispatch(toggleTeamSavedModal(false));
	}, [dispatch]);

	if (!isModalVisible) {
		return null;
	}

	return (
		<ModalBackdrop className="fade">
			<ModalContent>
				<ModalCloseButton onClick={closeModal}>
					<IconRemove />
				</ModalCloseButton>
				<InnerWrapper>
					<IconInfo color="#000151" width={66} height={66} />
					<ModalHeaderTitle>{t("team.name.save")}</ModalHeaderTitle>
					<ModalText>
						{t("team.name.league_prompt")}
					</ModalText>
				</InnerWrapper>
				<ModalActions>
					<SecondaryButton onClick={closeModal}>{t("team.name.edit")}</SecondaryButton>
					<PrimaryLink to={`/${project}/${sport}/leagues/create`}>
						{t("team.name.league_create")}
					</PrimaryLink>
				</ModalActions>
			</ModalContent>
		</ModalBackdrop>
	);
};
